function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.726 22.5a10.5 10.5 0 100-21 10.5 10.5 0 000 21zm0 1.5a12 12 0 100-24 12 12 0 000 24z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.974 11.69V1.5h1.5v9.75h9.75v1.5h-10.19l-7.28 7.281-1.061-1.062 7.28-7.28z",
  fill: "#fff"
});

function SvgChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgChart;